import React from "react";

/**
 * Badge visivo per identificare utenti registrati via Google OAuth.
 * Usato nella tabella /users (admin) accanto all'email — comunica al supporto
 * che questo utente NON ha una password interna e non può usare reset-password.
 *
 * Uso:
 *   <GoogleBadge user={u} />           // rende il badge solo se u.auth_provider === "google"
 *   <GoogleBadge user={u} size="xs" /> // dimensione custom
 */
export default function GoogleBadge({ user, size = "sm", className = "" }) {
  if (!user || user.auth_provider !== "google") return null;
  const sizeCls = size === "xs" ? "text-[9px] px-1 py-0" : "text-[10px] px-1.5 py-0.5";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-semibold bg-blue-50 text-blue-800 border border-blue-200 ${sizeCls} ${className}`}
      title="Utente registrato con Google — non ha password interna, il reset-password non è applicabile"
      data-testid={`google-badge-${user._id || user.id || "unknown"}`}
    >
      <svg viewBox="0 0 24 24" width={size === "xs" ? 8 : 10} height={size === "xs" ? 8 : 10} aria-hidden="true">
        <path fill="#4285F4" d="M23.49 12.27c0-.86-.08-1.68-.22-2.47H12v4.68h6.44c-.28 1.5-1.13 2.77-2.4 3.62v3.01h3.88c2.27-2.09 3.57-5.17 3.57-8.84z" />
        <path fill="#34A853" d="M12 24c3.24 0 5.95-1.08 7.94-2.92l-3.88-3.01c-1.08.72-2.45 1.15-4.06 1.15-3.13 0-5.78-2.11-6.73-4.96H1.28v3.11C3.26 21.3 7.31 24 12 24z" />
        <path fill="#FBBC05" d="M5.27 14.26c-.24-.72-.38-1.49-.38-2.26s.14-1.54.38-2.26V6.63H1.28C.46 8.24 0 10.06 0 12s.46 3.76 1.28 5.37l3.99-3.11z" />
        <path fill="#EA4335" d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.44-3.44C17.94 1.15 15.23 0 12 0 7.31 0 3.26 2.7 1.28 6.63l3.99 3.11C6.22 6.86 8.87 4.75 12 4.75z" />
      </svg>
      Google
    </span>
  );
}
